export default class BaseModel {
    #decamelize;

    constructor(id=null) {
        if (this.constructor === BaseModel) {
            throw new Error("Abstract classes can't be instantiated.");
        }
        this.id = id;
        this.decamelize = require('decamelize-keys-deep');

    }

    toJson() {
        return JSON.stringify(this.decamelize(this));
    }
}
